export const packages = {
  title: 'Packages',
  unlinkPackage: 'Remove link',
  linkPackage: 'Create link',
  deletePackage: 'Delete package',
  editPackage: 'Edit package',
  linkPackages: 'View possible links',
  addPackage: 'Add package',
  noPackagesAvailable:
    'No packages available. Create a new one to assign it to the option.',
} as const
